/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-array-index-key */
import React from "react";
import useComponentVisible from "../hooks/useComponentVisible";

type IIconType = {
  /**
   * Icon width
   */
  width?: string;
  /**
   * Icon height
   */
  height?: string;
  /**
   * Icon color
   */
  color?: string;
  /**
   * Icon fill
   */
  fill?: string;
  /**
   * Custom classstyling
   */
  className?: string;
  /**
   * Icon id
   */
  id?: string;
  /**
   * On click event on an icon
   */
  onClick?: any;
  /**
   * Icon reference
   */
  eRef?: any;
  /**
   * Icon  style
   */
  style?: object;
};

export const IEyeShow = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, style } = props;

  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      id={id}
      data-name="Icon Eye Show 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_27994" data-name="Rectangle 27994" width={width} height={height} fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(1.012 5.5)">
        <path
          id="Path_50420"
          data-name="Path 50420"
          d="M23.661,16.55h0c-1.05-1.3-4.95-5.55-10.65-5.55s-9.6,4.25-10.65,5.55a1.5,1.5,0,0,0,0,1.9c1.05,1.3,4.95,5.55,10.65,5.55s9.6-4.25,10.65-5.55A1.5,1.5,0,0,0,23.661,16.55ZM13.011,22c-4.4,0-7.65-3.1-8.85-4.5,1.2-1.4,4.45-4.5,8.85-4.5s7.65,3.1,8.85,4.5C20.661,18.9,17.411,22,13.011,22Z"
          transform="translate(-2.022 -11)"
          fill={color}
        />
        <circle id="Ellipse_2965" data-name="Ellipse 2965" cx="3" cy="3" r="3" transform="translate(7.989 3.5)" fill={color} />
      </g>
    </svg>
  );
};

IEyeShow.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const IEyeHide = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, style } = props;

  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      id={id}
      data-name="Icon Eye Hide 24px"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_27916" data-name="Rectangle 27916" width={width} height={height} fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(1.01 3.25)">
        <path
          id="Union_15"
          data-name="Union 15"
          d="M18.14,17.3l-2.9-2.85a11.537,11.537,0,0,1-4.25.8c-5.7,0-9.6-4.25-10.648-5.547a1.493,1.493,0,0,1,0-1.9A16.03,16.03,0,0,1,4.791,4L2.441,1.6A1,1,0,0,1,3.839.2L9.693,6.049a2.931,2.931,0,0,1,1.3-.3,3,3,0,0,1,3,3,2.931,2.931,0,0,1-.3,1.3L19.541,15.9a1,1,0,0,1-.389,1.777,1.1,1.1,0,0,1-.209.021A1.009,1.009,0,0,1,18.14,17.3Zm-16-8.549c1.2,1.4,4.453,4.5,8.85,4.5a9.478,9.478,0,0,0,2.7-.4l-1.4-1.4a2.836,2.836,0,0,1-1.3.3,3,3,0,0,1-3-3,2.876,2.876,0,0,1,.3-1.3l-2-2A14.762,14.762,0,0,0,2.14,8.752Zm15.4,2.148a17,17,0,0,0,2.3-2.148c-1.2-1.4-4.453-4.5-8.852-4.5h-.1L9.091,2.4a11.871,11.871,0,0,1,1.9-.152c5.7,0,9.6,4.248,10.65,5.551a1.5,1.5,0,0,1,0,1.9,15.108,15.108,0,0,1-2.7,2.6Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

IEyeHide.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const IWarning = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, style } = props;

  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      id={id}
      data-name="Icon Error Outline Dark Pink70% 16px"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_27992" data-name="Rectangle 27992" width={width} height={height} fill="none" />
      </g>
      <g id="paths" transform="translate(0.678 1.018)">
        <g id="Group_30251" data-name="Group 30251">
          <path
            id="Path_50417"
            data-name="Path 50417"
            d="M9.355,5.036l5.533,10H3.855l5.5-10M2.121,15.369a.667.667,0,0,0,.567,1H16.021a.667.667,0,0,0,.567-1l-6.667-12a.667.667,0,0,0-1.133,0Z"
            transform="translate(-2.032 -3.054)"
            fill={color}
          />
          <path
            id="Path_50418"
            data-name="Path 50418"
            d="M22,17.667v3a.667.667,0,0,0,1.333,0v-3a.667.667,0,0,0-1.333,0Z"
            transform="translate(-15.344 -12.351)"
            fill={color}
          />
          <circle
            id="Ellipse_2961"
            data-name="Ellipse 2961"
            cx="0.667"
            cy="0.667"
            r="0.667"
            transform="translate(6.656 9.649)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

IWarning.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#aa384b",
};

export const IDialogInfo = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, style } = props;

  return (
    <svg
      className={className}
      id={id}
      style={style}
      onClick={onClick}
      data-name="Illus Sml 200px - Are you sure"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 200 200"
    >
      <rect id="Container_10px_Padding" data-name="Container 10px Padding" width={width} height={height} fill="none" />
      <g id="Details" transform="translate(9 11.719)">
        <g id="Detail" transform="translate(0 0)">
          <g id="Background">
            <path
              id="Background_shape"
              data-name="Background shape"
              d="M116.916,200.8a85.056,85.056,0,0,1-3.5-8.03c-1.41-3.758-1.871-8.295-4.082-11.665-2.729-4.16-3.426-6.062-2.93-12.013.234-8.448.151-22.2,5.053-28.561s5.317-4.477,12.071-9.262c9.183-6.506,5.781-10.922,19.487-17.338,10.97-5.608,12-6.443,20.477-12.628,12.241-8.934,29.027-17.192,44.723-15.086,16.232,2.178,43.383,19.154,44.041,35.858.44,11.171,29.538,39.281,33.393,51.494,4,12.67-13.573,18.412-15.551,29.26-1.19,6.529,3.94,12.73,4.057,19.345.091,5.152-2.956,10.057-7.174,13.53s-9.516,5.687-14.876,7.464c-15.835,5.248-30.67,18.051-47.254,18.251-15.762.19-32.05-14.649-46.869-19.5-12.563-4.116-23.45-15.65-31.055-25.331A91.817,91.817,0,0,1,116.916,200.8Z"
              transform="translate(-106.26 -85.882)"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_43905" data-name="Group 43905" transform="translate(47.355 49.664)">
          <g id="Group_36572" data-name="Group 36572" transform="translate(2.88 1.641)">
            <path
              id="Path_227795"
              data-name="Path 227795"
              d="M-20021.168-12760.076l-12.984,2.573-16.73,14.39-6.492,19.046,3.375,18.227,8.713,9.1,13.734,8.243,10.385,3.081,12.412-3.081,14.83-8.243,8.373-14.764,1.84-14.373-1.84-14.172-8.373-8.089-8.906-6.992-5.924-2.369-5.117-2.573Z"
              transform="translate(20057.375 12760.076)"
              fill="#fff5cc"
            />
          </g>
          <g id="Group_36571" data-name="Group 36571">
            <path
              id="Union_18"
              data-name="Union 18"
              d="M.7,50.967c-.03-.03-.07-.068-.089-.085L0,50.432l.054-1.2c.016-.353.031-.676.047-1,.111-2.31.338-7.05.348-7.259,0-.049.013-.346.021-.578.045-1.26.07-2.544.1-3.786.031-1.487.062-3.023.124-4.547a18.086,18.086,0,0,1,.239-2.058c.069-.444.135-.863.175-1.271.1-1,.158-2.03.216-3.025l.027-.456c.022-.367.045-.74.068-1.1.073-1.139.148-2.317.158-3.447a18.915,18.915,0,0,0-.139-2.1c-.029-.282-.058-.572-.084-.866-.015-.174-.052-.375-.09-.589a4.813,4.813,0,0,1-.023-2.192A5.02,5.02,0,0,1,3.3,12.509a1.865,1.865,0,0,1,2.114.026,2.153,2.153,0,0,1,.92,1.827c-.021.7-.036,1.379,0,2.02.022.383.062.77.105,1.177a18.219,18.219,0,0,1,.137,2.057c-.005,1-.075,2-.142,2.961-.032.468-.066.952-.091,1.421-.017.323-.028.644-.039.985-.015.481-.031.977-.068,1.483-.032.428-.083.85-.131,1.256s-.093.776-.12,1.145c-.067.913-.095,1.839-.115,2.634-.029,1.12-.065,3.38-.065,3.4v.066l-.007.066c0,.021-.23,2.141-.254,3.151-.012.482.017.974.047,1.494.032.558.066,1.134.051,1.737-.016.659-.088,1.3-.157,1.929-.047.418-.091.814-.118,1.2-.041.584-.069,1.185-.1,1.767-.029.625-.059,1.271-.105,1.918a8.044,8.044,0,0,1-.288,1.477l-.022.083a2.454,2.454,0,0,1-1.462,1.65h0a3.146,3.146,0,0,1-1.107.24H2.223A2.171,2.171,0,0,1,.7,50.967ZM4.419,6.4A3.157,3.157,0,0,1,1.355,2.736,3.391,3.391,0,0,1,2.127,1.4,4.4,4.4,0,0,1,6.539.194,2.623,2.623,0,0,1,7.977,2.929c-.212,1.7-1.388,3.49-3.236,3.49A2.973,2.973,0,0,1,4.419,6.4Z"
              transform="translate(34.199 13.435)"
              fill="#1d1d1b"
            />
            <g id="Group_36570" data-name="Group 36570">
              <path
                id="Path_148202"
                data-name="Path 148202"
                d="M518.388,125.59c.57,11.279-3.531,20.322-10.5,28.3-3.739,4.28-8.753,6.547-13.754,8.8a43.8,43.8,0,0,1-16.57,3.545,28.734,28.734,0,0,1-10.9-1.953,30.481,30.481,0,0,1-12.686-8.317,12.448,12.448,0,0,0-2.522-2.472c-5.889-3.792-8.119-9.8-9.945-16.079-2.17-7.458-1.307-14.683,1.148-21.966A41.7,41.7,0,0,1,449.5,103.2a31.1,31.1,0,0,1,8.874-7.6c8.481-4.9,17.858-6.882,27.622-7.13a17.632,17.632,0,0,1,10.542,3.231c4.339,3,8.3,6.564,12.336,9.991,3.683,3.131,5.814,7.36,7.886,11.626C518.745,117.409,518.394,121.742,518.388,125.59Zm-4.406.293c.853-8.131-2.1-14.955-7.977-20.55-2.829-2.693-6.079-4.948-8.879-7.666-4.682-4.55-10.39-5.562-16.385-4.6A105.016,105.016,0,0,0,465.365,97a27.241,27.241,0,0,0-12.382,8.706c-3.811,4.545-5.936,10.07-7.578,15.786-1.959,6.819-.539,13.215,2.013,19.5,1.4,3.459,3.168,6.63,6.466,8.837a35.483,35.483,0,0,1,6.655,5.764c3.4,3.795,8.223,4.353,12.495,6.215,2.3,1,4.228-.173,6.326-.257,2.336-.095,4.691.152,6.957-.886,1.955-.894,4.079-1.411,6.092-2.193,5.577-2.164,10.806-5.063,14.25-10.034C511.289,141.757,514.743,134.509,513.982,125.883Z"
                transform="translate(-440.266 -88.471)"
                fill="#1d1d1b"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

IDialogInfo.defaultProps = {
  width: "200px",
  height: "200px",
  color: "#ffe67f",
};

export const ISideMenuOpen = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, fill, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 23.583"
    >
      <g id={`Icon_Open_Side_Menu ${id}`} data-name="Icon Open Side Menu" transform="translate(-164 -1033)">
        <g id="icons_Q2" data-name="icons Q2" transform="translate(164 1033)">
          <path
            id="Subtraction_32"
            data-name="Subtraction 32"
            d="M2.661,23.583H1.31A1.312,1.312,0,0,1,0,22.273V1.31A1.312,1.312,0,0,1,1.31,0H26.69A1.312,1.312,0,0,1,28,1.31V22.273a1.312,1.312,0,0,1-1.31,1.31H2.661Zm.446-21.3a.824.824,0,0,0-.823.823V20.5a.824.824,0,0,0,.823.823h21.9a.824.824,0,0,0,.823-.823V3.108a.824.824,0,0,0-.823-.823Z"
            transform="translate(0 0)"
            fill={color}
          />
        </g>
        <g id="icons_Q2-2" data-name="icons Q2" transform="translate(165.787 1042.999)">
          <g id="Group_43814" data-name="Group 43814">
            <path
              id="Path_376405"
              data-name="Path 376405"
              d="M12.378,12.208a.724.724,0,0,0-.931-.069.655.655,0,0,0-.069,1.035l2.276,2.276H8.69a.69.69,0,1,0,0,1.379h4.965L11.378,19.1a.655.655,0,0,0,.069,1.035.724.724,0,0,0,.931-.069l3.414-3.449a.655.655,0,0,0,0-.966Z"
              transform="translate(-8 -12.001)"
              fill={color}
            />
          </g>
        </g>
        <g
          id="Rectangle_35950"
          data-name="Rectangle 35950"
          transform="translate(174.792 1039)"
          fill={fill}
          stroke={color}
          strokeLinecap="round"
          strokeWidth="1"
        >
          <rect width="2" height="16.085" rx="1" stroke="none" />
          <rect x="0.5" y="0.5" width="1" height="15.085" rx="0.5" fill="none" />
        </g>
        <g
          id="Rectangle_35951"
          data-name="Rectangle 35951"
          transform="translate(191.001 1037.862) rotate(90)"
          fill={fill}
          stroke={color}
          strokeWidth="1"
        >
          <rect width="2" height="26.001" rx="1" stroke="none" />
          <rect x="0.5" y="0.5" width="1" height="25.001" rx="0.5" fill="none" />
        </g>
      </g>
    </svg>
  );
};

ISideMenuOpen.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
  fill: "#ffffff",
};

export const ISideMenuClose = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, fill, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Open_Side_Menu ${id}`}
      data-name="Icon Open Side Menu"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 23.583"
    >
      <g id="icons_Q2" data-name="icons Q2" transform="translate(0)">
        <path
          id="Subtraction_32"
          data-name="Subtraction 32"
          d="M2.661,23.583H1.31A1.312,1.312,0,0,1,0,22.273V1.31A1.312,1.312,0,0,1,1.31,0H26.69A1.312,1.312,0,0,1,28,1.31V22.273a1.312,1.312,0,0,1-1.31,1.31H2.661Zm.446-21.3a.824.824,0,0,0-.823.823V20.5a.824.824,0,0,0,.823.823h21.9a.824.824,0,0,0,.823-.823V3.108a.824.824,0,0,0-.823-.823Z"
          fill={color}
        />
      </g>
      <g id="icons_Q2-2" data-name="icons Q2" transform="translate(7 9.905)">
        <g id="Group_43814" data-name="Group 43814">
          <path
            id="Path_376405"
            data-name="Path 376405"
            d="M11.626,12.208a.724.724,0,0,1,.931-.069.655.655,0,0,1,.069,1.035L10.35,15.449h4.965a.69.69,0,1,1,0,1.379H10.35L12.626,19.1a.655.655,0,0,1-.069,1.035.724.724,0,0,1-.931-.069L8.212,16.622a.655.655,0,0,1,0-.966Z"
            transform="translate(-8 -12.001)"
            fill={color}
          />
        </g>
      </g>
      <g
        id="Rectangle_35950"
        data-name="Rectangle 35950"
        transform="translate(3.792 6)"
        fill={fill}
        stroke={color}
        strokeLinecap="round"
        strokeWidth="1"
      >
        <rect width="2" height="16.085" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="1" height="15.085" rx="0.5" fill="none" />
      </g>
      <g
        id="Rectangle_35951"
        data-name="Rectangle 35951"
        transform="translate(27 4.862) rotate(90)"
        fill={fill}
        stroke={color}
        strokeWidth="1"
      >
        <rect width="2" height="26.001" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="1" height="25.001" rx="0.5" fill="none" />
      </g>
    </svg>
  );
};

ISideMenuClose.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
  fill: "#ffffff",
};

export const IHamburgerMenu = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Hamburger_Menu_24x24 ${id}`}
      data-name="Icon Hamburger Menu 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_28192" data-name="Rectangle 28192" width={width} height={height} fill="none" />
      </g>
      <g id="Paths" transform="translate(3 5)">
        <g id="Group_41223" data-name="Group 41223">
          <path
            id="Path_338914"
            data-name="Path 338914"
            d="M24,11a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1H6a1,1,0,0,1,1-1H23A1,1,0,0,1,24,11Z"
            transform="translate(-6 -10)"
            fill={color}
          />
          <path
            id="Path_338915"
            data-name="Path 338915"
            d="M24,23a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1H6a1,1,0,0,1,1-1H23A1,1,0,0,1,24,23Z"
            transform="translate(-6 -16)"
            fill={color}
          />
          <path
            id="Path_338916"
            data-name="Path 338916"
            d="M24,35a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1H6a1,1,0,0,1,1-1H23A1,1,0,0,1,24,35Z"
            transform="translate(-6 -22)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

IHamburgerMenu.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const IBackArrow = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Back_Arrow_-_Generic_24x24 ${id}`}
      data-name="Icon Back Arrow - Generic 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_28000" data-name="Rectangle 28000" width="24" height="24" fill="none" />
      </g>
      <g id="Icon_paths" data-name="Icon paths" transform="translate(4.492 5)">
        <path
          id="Path_50430"
          data-name="Path 50430"
          d="M15.242,10.3l-5.95,6a.95.95,0,0,0,0,1.4l5.95,6a1.05,1.05,0,0,0,1.35.1.95.95,0,0,0,.1-1.5l-4.3-4.3h10.6a1,1,0,0,0,0-2h-10.6l4.3-4.3a.95.95,0,0,0-.1-1.5,1.05,1.05,0,0,0-1.35.1Z"
          transform="translate(-8.985 -10.001)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IBackArrow.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const IClose = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Close_Cancel_24x24 ${id}`}
      data-name="Icon Close Cancel 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <g id="Shape" fill="none" stroke="#1ecb40" strokeWidth="2" opacity="0">
          <rect width="24" height="24" stroke="none" />
          <rect x="1" y="1" width="22" height="22" fill="none" />
        </g>
      </g>
      <g id="Paths" transform="translate(4 4)">
        <path
          id="Path_331600"
          data-name="Path 331600"
          d="M19.6,17.983l6.058-6a1.2,1.2,0,0,0,.114-1.543,1.086,1.086,0,0,0-1.714-.114L18,16.383l-6.058-6.058a1.086,1.086,0,0,0-1.714.114,1.2,1.2,0,0,0,.114,1.543l6.058,6-6.058,6a1.2,1.2,0,0,0-.114,1.543,1.086,1.086,0,0,0,1.714.114L18,19.583l6.058,6.058a1.086,1.086,0,0,0,1.714-.114,1.2,1.2,0,0,0-.114-1.543Z"
          transform="translate(-10.001 -9.959)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IClose.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const ICheck = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, style } = props;

  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="Icons_-_Variations" data-name="Icons - Variations" transform="translate(-263.996)">
        <g id="Icon_Tickmark_24x24" data-name="Icon Tickmark 24x24" transform="translate(263.996)">
          <g id="invisible_box" data-name="invisible box">
            <rect id="Shape_bg" data-name="Shape bg" width={width} height={height} fill="none" />
          </g>
          <g id="Icon_Path" data-name="Icon Path" transform="translate(2.75 4.85)">
            <path
              id="Path_50399"
              data-name="Path 50399"
              d="M9.8,23.8l-4-3.95a1.05,1.05,0,0,1-.1-1.35.95.95,0,0,1,1.5-.1l3.3,3.3L22.3,9.9a1,1,0,0,1,1.4,1.4L11.2,23.8a.95.95,0,0,1-1.4,0Z"
              transform="translate(-5.501 -9.7)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

ICheck.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#4b996f",
};

export const IDashboard = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Dashboard_32x32 ${id}`}
      data-name="Icon Dashboard 32x32"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_35948" data-name="Rectangle 35948" width="32" height="32" fill="none" />
      </g>
      <g id="Lines" transform="translate(4 3)">
        <g id="Rectangle_35952" data-name="Rectangle 35952" fill={color} stroke={color} strokeWidth="2.4">
          <rect width="11" height="14" rx="1" stroke="none" />
          <rect x="1.2" y="1.2" width="8.6" height="11.6" rx="0.2" fill="none" />
        </g>
        <g
          id="Rectangle_35953"
          data-name="Rectangle 35953"
          transform="translate(13 12)"
          fill={color}
          stroke={color}
          strokeWidth="2.4"
        >
          <rect width="11" height="14" rx="1" stroke="none" />
          <rect x="1.2" y="1.2" width="8.6" height="11.6" rx="0.2" fill="none" />
        </g>
        <g
          id="Rectangle_35954"
          data-name="Rectangle 35954"
          transform="translate(13)"
          fill={color}
          stroke={color}
          strokeWidth="2.4"
        >
          <rect width="11" height="9" rx="1" stroke="none" />
          <rect x="1.2" y="1.2" width="8.6" height="6.6" rx="0.2" fill="none" />
        </g>
        <g
          id="Rectangle_35955"
          data-name="Rectangle 35955"
          transform="translate(0 17)"
          fill={color}
          stroke={color}
          strokeWidth="2.4"
        >
          <rect width="11" height="9" rx="1" stroke="none" />
          <rect x="1.2" y="1.2" width="8.6" height="6.6" rx="0.2" fill="none" />
        </g>
      </g>
    </svg>
  );
};

IDashboard.defaultProps = {
  width: "32px",
  height: "32px",
  color: "#1D1D1B",
};

export const IUpChevron = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Arrow_Up_24x24 ${id}`}
      data-name="Icon Arrow Up 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_27996" data-name="Rectangle 27996" width="24" height="24" fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(4 8)">
        <path
          id="Path_50422"
          data-name="Path 50422"
          d="M18,18.736l-6.058,6.058a1.086,1.086,0,0,1-1.714-.114,1.2,1.2,0,0,1,.114-1.543l6.858-6.8a1.086,1.086,0,0,1,1.6,0l6.858,6.8a1.2,1.2,0,0,1,.114,1.543,1.086,1.086,0,0,1-1.714.114Z"
          transform="translate(-10.001 -15.985)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IUpChevron.defaultProps = {
  width: "32px",
  height: "32px",
  color: "#1D1D1B",
};

export const IDownChevron = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Arrow_Down_24x24 ${id}`}
      data-name="Icon Arrow Down 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_27995" data-name="Rectangle 27995" width="24" height="24" fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(4 8)">
        <path
          id="Path_50421"
          data-name="Path 50421"
          d="M18,22.383l-6.058-6.058a1.086,1.086,0,0,0-1.714.114,1.2,1.2,0,0,0,.114,1.543l6.858,6.8a1.086,1.086,0,0,0,1.6,0l6.858-6.8a1.2,1.2,0,0,0,.114-1.543,1.086,1.086,0,0,0-1.714-.114Z"
          transform="translate(-10.001 -15.959)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IDownChevron.defaultProps = {
  width: "32px",
  height: "32px",
  color: "#1D1D1B",
};

export const IRightChevron = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      id={`Icon_Arrow_Up_24x24 ${id}`}
      onClick={onClick}
      data-name="Icon Arrow Up 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_27996" data-name="Rectangle 27996" width="24" height="24" fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(4 8)">
        <path
          id="Path_50422"
          data-name="Path 50422"
          d="M18,18.736l-6.058,6.058a1.086,1.086,0,0,1-1.714-.114,1.2,1.2,0,0,1,.114-1.543l6.858-6.8a1.086,1.086,0,0,1,1.6,0l6.858,6.8a1.2,1.2,0,0,1,.114,1.543,1.086,1.086,0,0,1-1.714.114Z"
          transform="translate(-10.001 -15.985)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IRightChevron.defaultProps = {
  width: "32px",
  height: "32px",
  color: "#1D1D1B",
};

export const IEdit = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Edit_16x16 ${id}`}
      data-name="Icon Edit 16x16"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_28195" data-name="Rectangle 28195" width="16" height="16" fill="none" />
      </g>
      <g id="Paths" transform="translate(1.334 1.334)">
        <path
          id="Path_339957"
          data-name="Path 339957"
          d="M15.128,8.922l-2.7-2.732a.633.633,0,0,0-.933,0l-8.63,8.63a.666.666,0,0,0-.2.466L2,18.651a.666.666,0,0,0,.666.666l3.365-.666a.666.666,0,0,0,.466-.2l8.63-8.6a.633.633,0,0,0,0-.933Zm-9.363,8.4-2.432.666L4,15.553l6.164-6.131L11.9,11.188Zm7.1-7.064L11.1,8.489l.866-.9,1.766,1.8Z"
          transform="translate(-2 -5.985)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IEdit.defaultProps = {
  width: "16px",
  height: "16px",
  color: "#1D1D1B",
};

export const IHelp = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Help_32x32 ${id}`}
      data-name="Icon Help 32x32"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_35957" data-name="Rectangle 35957" width="32" height="32" fill="none" />
      </g>
      <g id="Paths" transform="translate(1.334 1.334)">
        <g id="Path_376412" data-name="Path 376412" transform="translate(-2 -2)" fill="none">
          <path d="M2,16.667A14.6,14.6,0,1,0,6.276,6.276,14.667,14.667,0,0,0,2,16.667Z" stroke="none" />
          <path
            d="M 16.66658592224121 28.93325614929199 C 19.94313621520996 28.93325614929199 23.02356719970703 27.65729713439941 25.3404369354248 25.3404369354248 C 27.65729713439941 23.02356719970703 28.93325614929199 19.94313621520996 28.93325614929199 16.66658592224121 C 28.93325614929199 13.39004707336426 27.65729713439941 10.3096170425415 25.3404369354248 7.992746829986572 C 23.02356719970703 5.675886631011963 19.94313621520996 4.399926662445068 16.66658592224121 4.399926662445068 L 16.59966659545898 4.399776458740234 C 14.98953628540039 4.399776458740234 13.41892623901367 4.712146759033203 11.93145656585693 5.328206539154053 C 10.44368648529053 5.94438648223877 9.111886978149414 6.834246635437012 7.973076820373535 7.973066806793213 C 6.82763671875 9.118496894836426 5.934266567230225 10.45883655548096 5.317786693572998 11.95683670043945 C 4.701306819915771 13.45483684539795 4.392486572265625 15.03572654724121 4.399906635284424 16.65559577941895 L 4.399926662445068 16.66658592224121 C 4.399926662445068 19.94313621520996 5.675886631011963 23.02356719970703 7.992746829986572 25.3404369354248 C 10.3096170425415 27.65729713439941 13.39004707336426 28.93325614929199 16.66658592224121 28.93325614929199 M 16.66658592224121 31.33325576782227 C 8.56641674041748 31.33325576782227 1.999926686286926 24.76676750183105 1.999926686286926 16.66658592224121 C 1.982096672058105 12.77130699157715 3.521606683731079 9.030416488647461 6.276016712188721 6.276006698608398 C 9.030416488647461 3.521606683731079 12.77153491973877 1.98211145401001 16.66658592224121 1.999926686286926 C 24.76676750183105 1.999926686286926 31.33325576782227 8.56641674041748 31.33325576782227 16.66658592224121 C 31.33325576782227 24.76676750183105 24.76676750183105 31.33325576782227 16.66658592224121 31.33325576782227 Z"
            stroke="none"
            fill={color}
          />
        </g>
        <g id="Group_43833" data-name="Group 43833" transform="translate(8.682 5.338)">
          <path
            id="Path_332645"
            data-name="Path 332645"
            d="M23.333,36.687h-.267l-.267-.133h-.2l-.2-.2-.2-.2c0-.067-.067-.133-.133-.2s0-.2-.067-.267v-.533c.067-.067.067-.133.067-.267s.133-.133.133-.2l.2-.2a1.267,1.267,0,0,1,1.2-.4h.267l.2.133.2.2.2.2c0,.067.067.133.067.2a.505.505,0,0,0,.133.267v.533c-.067.067-.067.133-.133.267s-.067.133-.067.2l-.2.2-.2.2h-.2l-.267.133Z"
            transform="translate(-17.332 -18.03)"
            fill={color}
          />
          <path
            id="Path_332646"
            data-name="Path 332646"
            d="M21.267,23.337h-.533A1.333,1.333,0,0,1,20,21.6,4.867,4.867,0,0,1,22.4,19a3.267,3.267,0,0,0-.733-6.267,3.284,3.284,0,0,0-4,3.2,1.333,1.333,0,1,1-2.667,0,6.044,6.044,0,0,1,7.2-5.8,5.933,5.933,0,0,1,1.333,11.2,2.467,2.467,0,0,0-1.067,1.133A1.267,1.267,0,0,1,21.267,23.337Z"
            transform="translate(-15 -10.012)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

IHelp.defaultProps = {
  width: "32px",
  height: "32px",
  color: "#1D1D1B",
};

export const IInfo = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Info_Default_16x16 ${id}`}
      data-name="Icon Info Default 16x16"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_28173" data-name="Rectangle 28173" width="16" height="16" fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(0.666 0.666)">
        <path
          id="Path_332641"
          data-name="Path 332641"
          d="M9.333,2a7.3,7.3,0,1,0,5.2,2.138A7.333,7.333,0,0,0,9.333,2Zm0,13.333a6,6,0,1,1,6-6A6,6,0,0,1,9.333,15.333Z"
          transform="translate(-2 -2)"
          fill={color}
        />
        <path
          id="Path_332642"
          data-name="Path 332642"
          d="M22.667,20a.667.667,0,0,0-.667.667v4a.667.667,0,0,0,1.333,0v-4A.667.667,0,0,0,22.667,20Z"
          transform="translate(-15.333 -14)"
          fill={color}
        />
        <circle
          id="Ellipse_3760"
          data-name="Ellipse 3760"
          cx="0.667"
          cy="0.667"
          r="0.667"
          transform="translate(6.667 3.333)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IInfo.defaultProps = {
  width: "16px",
  height: "16px",
  color: "#1D1D1B",
};

export const ILeftChevron = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Arrow_Up_24x24 ${id}`}
      data-name="Icon Arrow Up 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_27996" data-name="Rectangle 27996" width="24" height="24" fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(4 8)">
        <path
          id="Path_50422"
          data-name="Path 50422"
          d="M18,18.736l-6.058,6.058a1.086,1.086,0,0,1-1.714-.114,1.2,1.2,0,0,1,.114-1.543l6.858-6.8a1.086,1.086,0,0,1,1.6,0l6.858,6.8a1.2,1.2,0,0,1,.114,1.543,1.086,1.086,0,0,1-1.714.114Z"
          transform="translate(-10.001 -15.985)"
          fill={color}
        />
      </g>
    </svg>
  );
};

ILeftChevron.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const IMoney = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Payment_Money_32x32 ${id}`}
      data-name="Icon Payment Money 32x32"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_35957" data-name="Rectangle 35957" width="32" height="32" fill="none" />
      </g>
      <g id="Paths" transform="translate(1.334 1.334)">
        <g id="Path_376412" data-name="Path 376412" transform="translate(-2 -2)" fill="none">
          <path d="M2,16.667A14.6,14.6,0,1,0,6.276,6.276,14.667,14.667,0,0,0,2,16.667Z" stroke="none" />
          <path
            d="M 16.66658592224121 28.93325614929199 C 19.94313621520996 28.93325614929199 23.02356719970703 27.65729713439941 25.3404369354248 25.3404369354248 C 27.65729713439941 23.02356719970703 28.93325614929199 19.94313621520996 28.93325614929199 16.66658592224121 C 28.93325614929199 13.39004707336426 27.65729713439941 10.3096170425415 25.3404369354248 7.992746829986572 C 23.02356719970703 5.675886631011963 19.94313621520996 4.399926662445068 16.66658592224121 4.399926662445068 L 16.59966659545898 4.399776458740234 C 14.98953628540039 4.399776458740234 13.41892623901367 4.712146759033203 11.93145656585693 5.328206539154053 C 10.44368648529053 5.94438648223877 9.111886978149414 6.834246635437012 7.973076820373535 7.973066806793213 C 6.82763671875 9.118496894836426 5.934266567230225 10.45883655548096 5.317786693572998 11.95683670043945 C 4.701306819915771 13.45483684539795 4.392486572265625 15.03572654724121 4.399906635284424 16.65559577941895 L 4.399926662445068 16.66658592224121 C 4.399926662445068 19.94313621520996 5.675886631011963 23.02356719970703 7.992746829986572 25.3404369354248 C 10.3096170425415 27.65729713439941 13.39004707336426 28.93325614929199 16.66658592224121 28.93325614929199 M 16.66658592224121 31.33325576782227 C 8.56641674041748 31.33325576782227 1.999926686286926 24.76676750183105 1.999926686286926 16.66658592224121 C 1.982096672058105 12.77130699157715 3.521606683731079 9.030416488647461 6.276016712188721 6.276006698608398 C 9.030416488647461 3.521606683731079 12.77153491973877 1.98211145401001 16.66658592224121 1.999926686286926 C 24.76676750183105 1.999926686286926 31.33325576782227 8.56641674041748 31.33325576782227 16.66658592224121 C 31.33325576782227 24.76676750183105 24.76676750183105 31.33325576782227 16.66658592224121 31.33325576782227 Z"
            stroke="none"
            fill={color}
          />
        </g>
        <path
          id="Doller_sign"
          data-name="Doller sign"
          d="M22.126,18.333c-2.333-.467-2.333-.867-2.333-1.2s.133-.4.333-.6a2.267,2.267,0,0,1,1.2-.267,4.2,4.2,0,0,1,2.2.6,1.2,1.2,0,0,0,1.8-.333,1.267,1.267,0,0,0-.267-1.867,6.067,6.067,0,0,0-2.067-.8V12.333a1.333,1.333,0,1,0-2.667,0V13.8a3.591,3.591,0,0,0-3.333,3.467c0,1.8,2.2,3.267,4.333,3.667s2.2.867,2.2,1.2-.733.933-1.667.933h0a4.467,4.467,0,0,1-2.733-.867,1.333,1.333,0,0,0-1.867.4,1.2,1.2,0,0,0,.2,1.733,7.267,7.267,0,0,0,2.867,1.2V27a1.333,1.333,0,1,0,2.667,0V25.533a4.2,4.2,0,0,0,2-.867A3.267,3.267,0,0,0,26.326,22h0C26.326,19.533,24.059,18.733,22.126,18.333Z"
          transform="translate(-6.986 -5)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IMoney.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const IProfile = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      onClick={onClick}
      id={`Icon_Profile_32px ${id}`}
      data-name="Icon Profile 32px"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_35869" data-name="Rectangle 35869" width="32" height="32" fill="none" />
      </g>
      <g id="Paths" transform="translate(15.666 -15.334)">
        <g id="Path_376412" data-name="Path 376412" transform="translate(-16.666 14.334)" fill="none">
          <path d="M2,17A14.932,14.932,0,1,0,6.373,6.373,15,15,0,0,0,2,17Z" stroke="none" />
          <path
            d="M 16.99985313415527 29.59977149963379 C 20.36541175842285 29.59977149963379 23.52952194213867 28.28915214538574 25.90934181213379 25.90934181213379 C 28.28915214538574 23.52952194213867 29.59977149963379 20.36541175842285 29.59977149963379 16.99985313415527 C 29.59977149963379 13.63429260253906 28.28915214538574 10.47017192840576 25.90934181213379 8.090352058410645 C 23.52952194213867 5.71054220199585 20.36541175842285 4.399922370910645 16.99985313415527 4.399922370910645 L 16.93143272399902 4.399762153625488 C 15.27752208709717 4.399762153625488 13.66419219970703 4.720622062683105 12.13627243041992 5.353442192077637 C 10.6080322265625 5.986382007598877 9.240022659301758 6.900442123413086 8.070232391357422 8.070232391357422 C 6.893651962280273 9.246811866760254 5.975992202758789 10.62359237670898 5.342751979827881 12.16232204437256 C 4.709502220153809 13.70105266571045 4.392282009124756 15.32494258880615 4.39990234375 16.98887252807617 L 4.399922370910645 16.99985313415527 C 4.399922370910645 20.36541175842285 5.71054220199585 23.52952194213867 8.090352058410645 25.90934181213379 C 10.47017192840576 28.28915214538574 13.63429260253906 29.59977149963379 16.99985313415527 29.59977149963379 M 16.99985313415527 31.9997730255127 C 8.715621948242188 31.9997730255127 1.999922156333923 25.28407287597656 1.999922156333923 16.99985313415527 L 1.999922156333923 16.99984169006348 C 1.98169219493866 13.01605224609375 3.556182146072388 9.190162658691406 6.37318229675293 6.373172283172607 C 9.190171241760254 3.556182622909546 13.01583099365234 1.981680750846863 16.99985313415527 1.999922156333923 C 25.28407287597656 1.999922156333923 31.9997730255127 8.715621948242188 31.9997730255127 16.99985313415527 C 31.9997730255127 25.28407287597656 25.28407287597656 31.9997730255127 16.99985313415527 31.9997730255127 Z"
            stroke="none"
            fill={color}
          />
        </g>
        <g
          id="Ellipse_3792"
          data-name="Ellipse 3792"
          transform="translate(-5.666 21.334)"
          fill="none"
          stroke={color}
          strokeWidth="2.4"
        >
          <circle cx="6" cy="6" r="6" stroke="none" />
          <circle cx="6" cy="6" r="4.8" fill="none" />
        </g>
        <g id="Intersection_10" data-name="Intersection 10" transform="translate(-18870 -17247)" fill="none">
          <path d="M18858.707,17287.813q.472-.574,1-1.105a6.538,6.538,0,1,1-1,1.105Z" stroke="none" />
          <path
            d="M 18870.283203125 17284.732421875 C 18868.623046875 17284.732421875 18867.005859375 17285.052734375 18865.474609375 17285.685546875 C 18864.2109375 17286.208984375 18863.056640625 17286.923828125 18862.033203125 17287.81640625 C 18864.31640625 17289.81640625 18867.24609375 17290.931640625 18870.333984375 17290.931640625 C 18873.412109375 17290.931640625 18876.333984375 17289.822265625 18878.61328125 17287.83203125 C 18876.333984375 17285.841796875 18873.412109375 17284.732421875 18870.333984375 17284.732421875 L 18870.283203125 17284.732421875 M 18870.283203125 17282.33203125 C 18870.298828125 17282.33203125 18870.31640625 17282.33203125 18870.333984375 17282.33203125 C 18875.013671875 17282.33203125 18879.19140625 17284.474609375 18881.943359375 17287.83203125 C 18879.19140625 17291.189453125 18875.013671875 17293.33203125 18870.333984375 17293.33203125 C 18865.64453125 17293.33203125 18861.458984375 17291.181640625 18858.70703125 17287.8125 C 18859.021484375 17287.4296875 18859.35546875 17287.060546875 18859.70703125 17286.70703125 C 18862.51171875 17283.90234375 18866.314453125 17282.33203125 18870.283203125 17282.33203125 Z"
            stroke="none"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

IProfile.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export const ISearch = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      ref={eRef}
      className={className}
      id={id}
      onClick={onClick}
      data-name="Icon Search 24x24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Shape" width={width} height={height} fill="none" />
      </g>
      <g id="Search_Paths" data-name="Search Paths" transform="translate(3 3.375)">
        <path
          id="Path_331599"
          data-name="Path 331599"
          d="M15.736,14.328a6.218,6.218,0,0,0,1.335-4.691,6.669,6.669,0,0,0-6.142-5.681A6.633,6.633,0,0,0,3.608,9.745a6.527,6.527,0,0,0,5.986,7.079,6.984,6.984,0,0,0,4.9-1.248l5.564,5.336a.865.865,0,0,0,1.246,0h0a.8.8,0,0,0,0-1.2Zm-4.5.775a5,5,0,0,1-4.278-1.351,4.634,4.634,0,0,1-1.33-4.157,4.73,4.73,0,0,1,3.961-3.83,4.959,4.959,0,0,1,4.312,1.3,4.592,4.592,0,0,1,1.34,4.17A4.861,4.861,0,0,1,11.241,15.1Z"
          transform="translate(-3.574 -3.924)"
          fill={color}
        />
      </g>
    </svg>
  );
};

ISearch.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#1D1D1B",
};

export type IMoreOptionItem = {
  name: string;
  onClick: any; // todo make function
};

type IMoreOptionProps = IIconType & { options: Array<IMoreOptionItem> };

export const IMoreOption = (props: IMoreOptionProps) => {
  const { options, onClick } = props;
  if (!options) return <></>;
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { width, height, id } = props;
  const handleClick = () => {
    onClick();
    setIsComponentVisible(!isComponentVisible);
  };
  return (
    <>
      <div className="menu-option">
        <svg
          id={`Icon_More_Option_32x32_${id}`}
          data-name="Icon More Option 32x32"
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox="0 0 32 32"
          onClick={handleClick}
        >
          <rect id="Grid_Box_32x32" data-name="Grid Box 32x32" width="32" height="32" fill="none" />
          <g id="Icon_Paths" data-name="Icon Paths" transform="translate(4 4)">
            <g id="invisible_box" data-name="invisible box">
              <rect id="Rectangle_27941" data-name="Rectangle 27941" width="24" height="24" fill="none" />
            </g>
            <g id="Icon_Dots" data-name="Icon Dots" transform="translate(1 9)">
              <g id="Dots">
                <circle id="Ellipse_1624" data-name="Ellipse 1624" cx="3" cy="3" r="3" fill="#1d1d1b" />
                <circle id="Ellipse_1625" data-name="Ellipse 1625" cx="3" cy="3" r="3" transform="translate(8)" fill="#1d1d1b" />
                <circle id="Ellipse_1626" data-name="Ellipse 1626" cx="3" cy="3" r="3" transform="translate(16)" fill="#1d1d1b" />
              </g>
            </g>
          </g>
        </svg>
        {isComponentVisible && (
          <div ref={ref} className="button-container">
            {options.map((item: IMoreOptionItem, index: number) => {
              return (
                <div key={index}>
                  <button
                    style={{ color: "#3f3e38" }}
                    className="button text text-size-18"
                    type="button"
                    onClick={() => item.onClick(index)}
                  >
                    {item.name}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
IMoreOption.defaultProps = {
  width: "32px",
  height: "32px",
};

export const ICalendar = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, id, onClick } = props;

  return (
    <svg
      id={`Icon_Calendar_16x16_${id}`}
      data-name="Icon Calendar 16x16"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      onClick={onClick}
    >
      <g id="invisible_box" data-name="invisible box">
        <rect id="Rectangle_28305" data-name="Rectangle 28305" width="24" height="24" fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(0.999 0.987)">
        <path
          id="Path_345238"
          data-name="Path 345238"
          d="M33,28H31a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V29A1,1,0,0,0,33,28Zm0,0H31a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V29A1,1,0,0,0,33,28Z"
          transform="translate(-16 -14.989)"
        />
        <path
          id="Path_345239"
          data-name="Path 345239"
          d="M23,4.989H18.5V3.039a1.05,1.05,0,0,0-.85-1.05,1,1,0,0,0-1.15,1v2h-7V3.039a1.05,1.05,0,0,0-.85-1.05,1,1,0,0,0-1.15,1v2H3a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1v-16A1,1,0,0,0,23,4.989Zm-1,16H4v-10H22Zm0-12H4v-2H22Z"
          transform="translate(-2 -1.977)"
        />
        <rect id="Rectangle_28306" data-name="Rectangle 28306" width="4" height="4" rx="2" transform="translate(14 13.011)" />
      </g>
    </svg>
  );
};

ICalendar.defaultProps = {
  width: "16px",
  height: "16px",
  color: "#1D1D1B",
};

export const IStatement = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      id={id}
      onClick={onClick}
      ref={eRef}
      data-name="statement"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 60 56.842"
    >
      <rect id="Rectangle_36023" data-name="Rectangle 36023" width={width} height={height} rx="8" fill="#f2fbfc" />
      <g id="Icon_Send_Paylink_32x32" data-name="Icon Send Paylink 32x32" transform="translate(12.468 12)">
        <rect
          id="Grid_Box_32x32"
          data-name="Grid Box 32x32"
          width={width}
          height={height}
          transform="translate(1.532)"
          fill="none"
        />
        <path
          id="Path_356802"
          data-name="Path 356802"
          d="M134.471,50.4a4.5,4.5,0,0,0-4.485,4.485V70.331H127a1,1,0,0,0-1,1v1.993a4.331,4.331,0,0,0,4.319,4.319h14.617a4.331,4.331,0,0,0,4.319-4.319V54.883a2.465,2.465,0,0,1,2.492-2.492,1,1,0,0,0,0-1.993Zm0,1.993h13.548a4.479,4.479,0,0,0-.758,2.492V73.321a2.3,2.3,0,0,1-2.325,2.325h-.28a.986.986,0,0,0-.187-.052,2.3,2.3,0,0,1-1.858-2.274V71.327a1,1,0,0,0-1-1h-9.634V54.883a2.465,2.465,0,0,1,2.492-2.492Zm-.27,3.987a1,1,0,1,0,.1,1.993h4.651a1,1,0,1,0,0-1.993H134.3a.968.968,0,0,0-.1,0Zm0,3.322a1,1,0,1,0,.1,1.993h10.631a1,1,0,1,0,0-1.993H134.3a.97.97,0,0,0-.1,0Zm0,3.322a1,1,0,1,0,.1,1.993h10.631a1,1,0,1,0,0-1.993H134.3a.965.965,0,0,0-.1,0Zm0,3.322a1,1,0,1,0,.1,1.993h4.651a1,1,0,1,0,0-1.993H134.3a.97.97,0,0,0-.1,0Zm-6.208,5.98h12.624v1a4.22,4.22,0,0,0,.748,2.325H130.318a2.3,2.3,0,0,1-2.325-2.325Z"
          transform="translate(-121.8 -48.398)"
          fill={color}
        />
      </g>
    </svg>
  );
};

IStatement.defaultProps = {
  width: "60px",
  height: "60px",
  color: "#09828b",
};

export const ICaret = (props: IIconType) => {
  if (!props) return <></>;

  const { width, height, color, className, id, onClick, eRef } = props;

  return (
    <svg
      id={id}
      className={className}
      onClick={onClick}
      ref={eRef}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g id="Icon_Arrow_Up_24x24" data-name="Icon Arrow Up 24x24" transform="translate(24 24) rotate(180)">
        <g id="invisible_box" data-name="invisible box">
          <rect id="Rectangle_27996" data-name="Rectangle 27996" width={width} height={height} fill="none" />
        </g>
        <g id="icons_Q2" data-name="icons Q2" transform="translate(4 8)">
          <path
            id="Path_50422"
            data-name="Path 50422"
            d="M18,18.736l-6.058,6.058a1.086,1.086,0,0,1-1.714-.114,1.2,1.2,0,0,1,.114-1.543l6.858-6.8a1.086,1.086,0,0,1,1.6,0l6.858,6.8a1.2,1.2,0,0,1,.114,1.543,1.086,1.086,0,0,1-1.714.114Z"
            transform="translate(-10.001 -16.985)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

ICaret.defaultProps = {
  width: "24px",
  height: "24px",
  color: "#09828b",
};
